import React, { useState } from 'react';
import {
  IconButton,
  Menu,
  MenuItem,
  ListItemIcon,
  Divider,
  useTheme,
  Typography,
} from '@mui/material';
import { HelpCircle } from 'react-feather';
import { Video, ThumbsUp, Gift } from 'react-feather';

const HelpMenuItem = ({
  href,
  Icon,
  text,
}: {
  href: string;
  Icon: React.ElementType;
  text: string;
}) => {
  const theme = useTheme();
  return (
    <MenuItem component="a" target="_blank" href={href}>
      <ListItemIcon>
        <Icon style={{ color: theme.palette.primary.main }} />
      </ListItemIcon>
      <Typography
        sx={{
          paddingTop: '4px',
          paddingBottom: '4px',
          fontSize: '16px',
          color: theme.palette.primary.main,
          paddingLeft: '8px',
        }}
      >
        {text}
      </Typography>
    </MenuItem>
  );
};

export const HelpMenu = () => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <IconButton
        title="Help Menu"
        aria-label="Help Menu"
        onClick={handleClick}
        style={{ padding: '10px' }}
        aria-controls={open ? 'help-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
      >
        <HelpCircle color={theme.palette.common.white} />
      </IconButton>

      <Menu
        id="help-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <HelpMenuItem
          href="https://help.perfectvenue.com/knowledge/training-video-for-venues"
          Icon={Video}
          text="Training Video"
        />

        <HelpMenuItem
          href="https://perfectvenue.canny.io/feature-requests"
          Icon={ThumbsUp}
          text="Feedback"
        />

        <HelpMenuItem
          href="https://form.typeform.com/to/vNu4kAfJ"
          Icon={Gift}
          text="Refer a Friend"
        />

        <Divider />

        <HelpMenuItem
          href="https://help.perfectvenue.com/knowledge"
          Icon={HelpCircle}
          text="Help Center"
        />
      </Menu>
    </>
  );
};

export default HelpMenu;
